'use strict';
import angular from 'angular';

angular.module('app.services')
        .factory('NavigationService', function( $q) {
            var factory = {};

            factory.navigation = [];
            factory.userRoleAllowStateNames = {
                'superadmin': [],
                'client': [
                    'orders', 
                    'addOrder', 
                    'editOrder', 
                    'viewOrder',
                    'addLineItem',
                    'editLineItem',
                    'viewLineItem',
                    'viewOrderTask',
                    'auditHistory'
                ],
                'adops_admin': [],   //ad operations manager
                'adops': [],   //ad operations
                'sales': [],   //sales
                'sales_admin': [],   //sales manager
                'vendor': [],
                'vendor-restricted': [],
                'partner_vendor-restricted': [],
                'viewer': [
                    'orders',
                    'detailedOrders',
                    'viewOrder',
                    'viewLineItem',
                    'viewOrderTask',
                    'auditHistory'
                ],
                'sales_viewer': [
                    'orders',
                    'detailedOrders',
                    'viewOrder',
                    'viewLineItem',
                    'viewOrderTask',
                    'auditHistory'
                ]
            };

            factory.addPath = function(toState, toParams, fromState, fromParams){
                if(toState.data){
                    if(toState.data.primary){

                        factory.navigation = [];

                    } else {

                        var path = {};
                        path.toState = toState.name;
                        path.params = toParams;
                        factory.navigation.push(path);

                    };

                };

                //console.log(factory.navigation);
            };

            factory.removePath = function(toState, toParams, fromState, fromParams){

            };

            factory.isAuthorisedStateName = function(userRole, toState){
                var currentRoleObj = angular.copy(userRole);
                if(currentRoleObj && currentRoleObj.permissions && currentRoleObj.permissions.includes(',')) {
                    currentRoleObj.permissions = currentRoleObj.permissions.replace(/,/g, '_');
                }
                var allowStateNames = factory.userRoleAllowStateNames[currentRoleObj.permissions];
                if(allowStateNames && allowStateNames.length > 0 && allowStateNames.indexOf(toState.name) === -1){
                    return false;
                }
                return true;
            }

            return factory;

        });